import { gql } from "@apollo/client";

export const GET_LIST_ACCOUNTING_FIRMS_QUERY = gql`
  query ($limit: Int, $offset: Int, $orderBy: [String], $filter: AccountingFirmFilter) {
    listAccountingFirmsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        vatNumber
        name
        emails
        phones
        settings {
          defaultSsiType {
            label
            value
          }
        }
      }
    }
  }
`;

export const LIST_ACCOUNTING_FIRMS_SELECT_QUERY = gql`
  query ($limit: Int, $offset: Int, $orderBy: [String], $filter: AccountingFirmFilter) {
    listAccountingFirmsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
        settings {
          defaultSsiType {
            label
            value
          }
          accountingPlanType {
            value
          }
        }
      }
      totalCount
    }
  }
`;

export const LIST_ACCOUNTING_FIRMS_SELECT_QUERY_WITH_FILTER = gql`
  query ($limit: Int, $offset: Int, $orderBy: [String], $search: String) {
    listAccountingFirmsPaginated(filter: { name_Icontains: $search }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
      }
      totalCount
    }
  }
`;

export const GET_ACCOUNTING_FIRMS_HEADER = gql`
  query getAccountingFirmHeader($id: ID!) {
    getAccountingFirm(id: $id) {
      id
      name
      logo
      settings {
        accountingPlanType {
          label
          value
        }
        defaultSsiType {
          label
          value
        }
      }
    }
  }
`;

export const GET_ACCOUNTING_FIRMS_BY_ID_QUERY = gql`
  query getAccountingFirmInfo($id: ID!) {
    getAccountingFirm(id: $id) {
      id
      name
      shortName
      businessName
      vatNumber
      logo
    }
  }
`;

export const GET_ACCOUNTING_CONTACTS = gql`
  query getAccountingFirmContacts($id: ID!) {
    getAccountingFirm(id: $id) {
      id
      website
      emails
      phones
      fax
    }
  }
`;

export const GET_SETTINGS_ACCOUNTING_FIRMS = gql`
  query getAccountingFirmSettings($id: ID!) {
    getAccountingFirmSettings(id: $id) {
      defaultSsiType {
        label
        value
      }
      language {
        label
        value
      }
      defaultNotificationEmail
      nameGeneratorChoices {
        label
        value
      }
      nameGeneratorSeparator {
        label
        value
      }
      nameGeneratorDateFormat {
        label
        value
      }
      halfNeossiReportsPeriod {
        label
        value
      }
      emailFilesAllowedEmails
      serializeDocumentsInExport
      accountingPlanType {
        label
        value
      }
    }
  }
`;

export const GET_OPTIONS_ACCOUNTING_FIRM = gql`
  query {
    listSsiTypeChoices {
      label
      value
    }
    listLanguageChoices {
      label
      value
    }
    listNameGeneratorChoices {
      label
      value
    }
    listNameGeneratorSeparatorChoices {
      label
      value
    }
    listDateFormatChoices {
      label
      value
    }
    listHalfReportRemarksPeriodChoices {
      label
      value
    }
    listAccountingPlanTypeChoices {
      label
      value
    }
  }
`;

export const UPDATE_ACCOUNTING_FIRM = gql`
  mutation updateAccountingFirm($input: UpdateAccountingFirmInput) {
    updateAccountingFirm(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_ACCOUNTING_FIRM_SETTINGS = gql`
  mutation updateAccountingFirmSettings($input: UpdateAccountingFirmSettingInput) {
    updateAccountingFirmSettings(input: $input) {
      accountingFirmSetting {
        nameGeneratorChoices {
          label
          value
        }
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const ADD_ACCOUNTING_FIRM = gql`
  mutation createAccountingFirm($input: CreateAccountingFirmInput!) {
    createAccountingFirm(input: $input) {
      accountingFirm {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const GET_LOGO_ACCOUNTING_FIRM = gql`
  query ($ids: [ID], $limit: Int) {
    listAccountingFirmsPaginated(filter: { id_In: $ids }) {
      totalCount
      results(limit: $limit, offset: 0) {
        id
        name
        logo
      }
    }
  }
`;

export const GET_PLATFORMS_LIST = gql`
  query listPlatforms($accountingFirmID: ID, $limit: Int, $offset: Int) {
    listPlatforms(filter: { accountingFirmId: $accountingFirmID }) {
      results(limit: $limit, offset: $offset) {
        id
        name
        software {
          label
          value
        }
        remoteAccountingFirmId
        apiUrl
      }
      totalCount
    }
  }
`;

export const LIST_ACCOUNTING_FIRMS_QUERY = gql`
  query listAccountingFirmsPaginated(
    $orderBy: [String]
    $search: String
    $limit: Int
    $offset: Int
    $companies_Settings_SsiType_In: [String]
    $deletedAtIsnull: Boolean
  ) {
    listAccountingFirmsPaginated(
      filter: {
        name_Icontains: $search
        companies_Settings_SsiType_In: $companies_Settings_SsiType_In
        deletedAt_Isnull: $deletedAtIsnull
      }
    ) {
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
      }
      totalCount
    }
  }
`;
